module.exports = __webpack_public_path__ + "img/goal-01.455a5dfe.png";